import { Networks } from '@rango-dev/widget-embedded';
export const supportedBlockchainsDisplayName = { [Networks.ETHEREUM]: 'EVM' };
